// import request from '../axios';

import {AxiosRequestHeaders} from 'axios';
import {ISendMessagePayload} from '../../models/payload/sendMessagePayload';
import request from '../axios';

export const getMessages = async () => {
  const {data}: {data: IMessages} = await request.get(
    `/api/v2/chat/user-chat?app=SUPPLIER`,
  );
  return data;
};

export const getRoom = async (ctx: string, pageParam: number) => {
  const {data}: {data: IRoomMessages} = await request.get(
    `/api/v2/chat/chats/` + ctx + '?page=' + pageParam,
  );
  return data;
};

export const sendMessage = async (payload: ISendMessagePayload) => {
  const {data}: {data: IResponse} = await request.post(
    `/api/v2/chat/send-message`,
    payload,
  );
  return data;
};

export const deleteMessage = async (payload: IRemoveMessagePayload) => {
  const {data}: {data: IResponse} = await request.delete(
    `/api/v2/chat?guid=` + payload?.guid,
    {
      headers: {} as AxiosRequestHeaders,
      data: {...payload},
    },
  );
  return data;
};

export const sendReplyMessage = async (payload: ISendReplyMessagePayload) => {
  const {data}: {data: IReplyMessage} = await request.post(
    `/api/v2/chat/send-message`,
    payload,
  );
  return data;
};
